import React from 'react';
import NavDatesSelector from './NavDatesSelector';
import NavDropdown from './NavDropdown';
import NavYearSelector from './NavYearSelector';
import { isUserAdmin, isUserOwner } from '../../../helpers';
import DeskBookingLink from '../../elements/DeskBookingLink';
import NavToday from '../../elements/NavToday';
import UserSelect from '../../elements/UserSelect';
import type { NavProps } from '../../../types';

const CalendarNavBigScreen = (props: NavProps): React.ReactElement => {
  const {
    navDates,
    isCalendar,
    isYearCalendar,
    currentUser,
    selectedUser,
    selectedYear,
    users,
    onNavTodayClick,
    onNavPrevWeekClick,
    onNavNextWeekClick,
    onSelectedUserChange,
    onToggleStatistics,
    onNavPrevYearClick,
    onNavNextYearClick,
    onNavYearCalendarClick,
    onPayrollGeneratorClick,
    onMarketingStatsClick,
    onOpenCheckinModal,
    hasActiveIncidents,
  } = props;
  const isAdmin = isUserAdmin(currentUser);
  const isOwner = isUserOwner(currentUser);

  return (
    <div className="device-big">
      <div className="row">
        <nav className="navbar navbar-default nav-flex">
          <div className="container-fluid">
            <div className="today-btn-wrapper">
              <NavToday isCalendar onNavTodayClick={onNavTodayClick as any} />
              {!isYearCalendar && (
                <button
                  type="button"
                  className="btn mini-stats-btn js-curr-week"
                  onClick={onToggleStatistics as any}
                >
                  Mini Stats
                </button>
              )}
              {!isYearCalendar && (
                <button
                  type="button"
                  className="btn mini-stats-btn js-curr-week"
                  onClick={onNavYearCalendarClick as any}
                >
                  Year Calendar
                </button>
              )}
              <DeskBookingLink />
              {currentUser && currentUser.needsRemoteCheckin && (
                <button
                  type="button"
                  className="btn mini-stats-btn js-curr-week"
                  onClick={onOpenCheckinModal}
                >
                  Check In
                </button>
              )}
              {isYearCalendar && (
                <button
                  type="button"
                  className="btn mini-stats-btn js-curr-week"
                  onClick={() => (onNavTodayClick as any)('to-week-calendar')}
                >
                  Week Calendar
                </button>
              )}
            </div>
            <NavDatesSelector
              isCalendar={isCalendar || false}
              navDates={navDates as any}
              onNavPrevWeekClick={onNavPrevWeekClick as any}
              onNavNextWeekClick={onNavNextWeekClick as any}
            />
            <NavYearSelector
              selectedYear={selectedYear || new Date().getFullYear()}
              isYearCalendar={isYearCalendar || false}
              onNavPrevYearClick={onNavPrevYearClick as any}
              onNavNextYearClick={onNavNextYearClick as any}
            />
            <div className="nav-right">
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {(isAdmin || isOwner) && (
                  <a href="/incidents" style={{ cursor: 'pointer', marginRight: '12px', marginTop: '10px', textDecoration: 'none' }}>
                    <i className="fa fa-exclamation-triangle"
                       style={{ color: hasActiveIncidents ? '#f0ad4e' : '#ccc', fontSize: '18px' }} />
                  </a>
                )}
                {isAdmin || isOwner ? (
                  <UserSelect
                    users={users}
                    selectedUser={selectedUser}
                    onSelectedUserChange={onSelectedUserChange as any}
                  />
                ) : null}
                <NavDropdown isAdmin={isAdmin} isOwner={isOwner} selectedUser={selectedUser} onPayrollGeneratorClick={onPayrollGeneratorClick} onMarketingStatsClick={onMarketingStatsClick} />
              </div>
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default CalendarNavBigScreen;
